import angular from 'angular';

angular.module('cloudX').directive('validateEnterpriseNumber', function() {
  return {
    restrict: 'A',
    require: ['?ngModel', '^?bindErrors'],
    link: function(scope, element, attrs, ctrls) {
      var ngModel = ctrls[0];
      var bindErrors = ctrls[1];
      if (!ngModel) return; // do nothing if no ng-model
      attrs.$observe('validateEnterpriseNumber', function(country) {
        var ctry = scope.$eval(country) || country || '';
        if (!ctry) return;
        ngModel.$validators.enterpriseNumber = function(modelValue, viewValue) {
          var value = modelValue || viewValue || null;
          if (value === null) return true; //Allow null and empty values
          //Only check for Belgian numbers
          if (ctry.toUpperCase() !== 'BE') return true;
          if (!/^[0-9]{4}.?[0-9]{3}.?[0-9]{3}$/.test(value)) return false;
          //Replace invalid characters and spaces
          value = value.replace(/[^0-9]/g, '');
          if (value.length !== 10) return false;
          var toTest = value.substr(0, 8);
          var mod = parseInt(toTest) % 97;
          return mod + parseInt(value.substr(8)) === 97;
        };
      });
      if (bindErrors) {
        bindErrors.addError('enterpriseNumber', 6017);
        //ngModel.$viewChangeListeners.push(function () {
        //    bindErrors.refreshErrors(ngModel.$error);
        //});
        //scope.$on('$destroy', function () {
        //    bindErrors.refreshErrors();
        //});
      }
    },
  };
});
